export default "__VITE_ASSET__BspCCVJN__"